import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Button,Input,Label } from 'reactstrap';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import FetchSubmissionListService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionListService';
import CustomModal from '../../../../../../../Components/Modals/CustomModal';
import FetchAssetsbySubmissionService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchAssetsbySubmissionService';
import ProjectDocumentDeliveriesDetails,{ ProjectGraphicsDeliveriesDetails } from './ProjectDeliveriesDetails';
import AddSubmissionsChatService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AddSubmissionsChatService';
import FetchSubmissionsChatsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionsChatsService';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'react-loaders';
import ProjectDashDeliveriesImagesDetails from './ProjectDashDeliveriesImagesDetails';
function ProjectDashDeliveries(props) {
  const [submissionSearchText, setSubmissionSearchText] = useState('');
  const [submissionList, setSubmissionList] = useState([]);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [selectedCurrentPage, setSelectedCurrentPage] = useState(1);
  const [graphicsAssets,setGraphicsAssets]=useState('')
  const [documentAssets,setDocumentAssets]=useState('')
  const [isCommentsPopUpOPen, setIsCommentsPopUpOPen] = useState(false);
  const [filePath, setFilePath]= useState('');
  const [demoImage, setDemoImage] = useState()
  const [comment, setComment] = useState('');
  const [noteList, setNoteList] = useState([]);
  const [selectedFileObject, setSelectedFileObject] = useState({});
  const [loadScreen, setLoadScreen] = useState(false);
  const [loggedInUser,setLoggedInUser]= useState('');
  const [allAssetsList,setAllAssetsList]=useState('')
  const [documentStatusCount, setDocumentStatusCount] = useState({});
  const [documentTotal, setDocumentTotal] = useState(0);
  const [graphicsStatusCount, setGraphicsStatusCount] = useState({});
  const [graphicsTotal, setGraphicsTotal] = useState(0);
useEffect (()=>{
  let data={
    projectId:props.selectedProjectData.projectId,
    submissionFor:''
  }
  setLoadScreen(true)
  FetchSubmissionListService(props.token,data).then((res)=>{
    if(res){
      console.log(res);
      setLoggedInUser(res.loggedInUser)
      setSubmissionList(res.submissionList)
      if (res.submissionList[0] != null){
        fetchSubmissionDetails(res.submissionList[0])
        
      }
      
    }
    setLoadScreen(false)
  })
},[])


const hasAssetType = (assets, type) => {
  return assets && assets.some(asset => asset.assetSubCategory === type);
};

const fetchSubmissionDetails = (submisionInfo) => {
  console.log(submisionInfo);
  const data = {
    submissionAssetId: submisionInfo.id,
  };
  setSelectedSubmission(submisionInfo);
  setLoadScreen(true);
  
  FetchAssetsbySubmissionService(props.token, data).then((res) => {
    if (res && res.assetList) {
      setAllAssetsList(res.assetList);
       // Set document status counts
       if (res.documentStatusCount) {
        setDocumentStatusCount(res.documentStatusCount);
      }
      if (res.documentTotal !== undefined) {
        setDocumentTotal(res.documentTotal);
      }
      
      // Set graphics status counts
      if (res.graphicsStatusCount) {
        setGraphicsStatusCount(res.graphicsStatusCount);
      }
      if (res.graphicsTotal !== undefined) {
        setGraphicsTotal(res.graphicsTotal);
      }
      // Check what types of assets we have
      const hasDocuments = hasAssetType(res.assetList, 5); // 5 is document type
      const hasGraphics = hasAssetType(res.assetList, 7);  // 7 is graphics type
      
      // Determine which tab to select
      let tabToSelect = 1; // Default to Documents tab
      if (hasDocuments && hasGraphics) {
        tabToSelect = 1; // If both, default to Documents as per requirement
      } else if (hasGraphics) {
        tabToSelect = 2; // Only graphics
      } else if (hasDocuments) {
        tabToSelect = 1; // Only documents
      }
      
      handleSelectedTab(tabToSelect, res.assetList);
    }
    setLoadScreen(false);
  });
};

const handleSelectedTab = (page, info = allAssetsList) => {
  console.log(page);
  setSelectedCurrentPage(page);
  if(page === 1) {
    const filterDoc = info && info.filter((assets) => assets.assetSubCategory === 5) || [];
    setDocumentAssets(filterDoc);
  } else {
    const filterGraphics = info && info.filter((assets) => assets.assetSubCategory === 7) || [];
    setGraphicsAssets(filterGraphics);
    setSelectedFileObject(filterGraphics[0] || {});
  }
};
  const filteredSubmissions = (submissionList || []).filter((item) => {
    const search = submissionSearchText.toLowerCase();
    return (
      (item.submissionName && item.submissionName.toLowerCase().includes(search)) ||
      (item.submittedFor && item.submittedFor.toLowerCase().includes(search)) ||
      (item.submittedBy && String(item.submittedBy).toLowerCase().includes(search)) ||
      (item.submittedOn && String(item.submittedOn).toLowerCase().includes(search))
    );
  });
  const column = [
    { 
      Header: "Submission Name", 
      accessor: "submissionName",
      Cell: (rowInfo) => {
        const submission = rowInfo.original;
        return (
          <span
            style={{ 
              cursor: 'pointer', 
              color: '#0066cc'
            }}
            onClick={() => {
              fetchSubmissionDetails(submission)
              setSelectedSubmission(submission);
            }}
          >
            {rowInfo.value}
          </span>
        );
      }
    },
    { Header: "Submitted On", accessor: "submittedOn" },
    { Header: "Submitted By", accessor: "submittedBy" }
  ];
const handleImgdetails=(details)=>{
  console.log(details);
  setIsCommentsPopUpOPen(true)
  setFilePath(details.filePath)
  setSelectedFileObject(details)
  let data = {
    assetId: details.id
}
// setLoadScreen(true);
FetchSubmissionsChatsService(props.token, data).then((res) => {
    console.log(res)
    setNoteList(res);
    // setLoadScreen(false);
})
setIsCommentsPopUpOPen(true);
showNote(details.fileName, details.filePath)
}

const showNote = (path, fullPath) => {
  console.log(path);
  const ext = path.split(".")[1];
  if (ext == "xlsx" || ext == "csv" || ext == "xls" || ext == "docx" || ext == "doc" || ext == 'xlsm') {
      setDemoImage(true)
  } else {
      setFilePath(fullPath);
      setDemoImage(false)
  }
};
  return (
    <>
        
              <Card className="card-of-problemarea p-3 mt-1 ml-3">
                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="mb-0 mr-3 "><b>Deliveries</b></h5>
                  <Input 
                    type="text"
                    placeholder="Search Text"
                    className="w-25"
                    value={submissionSearchText}
                    onChange={(e) => setSubmissionSearchText(e.target.value)}
                  />
                  </div>
                  <ReactTable
                      data={filteredSubmissions}
                      columns={column}
                      defaultPageSize={3}
                      showPageSizeOptions={false} // optional, hides dropdown if you don’t want users changing page size
                      className="-fixed -highlight -striped mt-2"
                      noDataText="No data found..."
                      getTheadProps={() => ({
                        style: {
                          overflow: "hidden",
                          background: "#B1FA63",
                          color: "#243837",
                        },
                      })}
                      getTrProps={(state, rowInfo) => {
                        if (!rowInfo) return {};
                        const isSelected =
                          selectedSubmission && rowInfo.original.id === selectedSubmission.id;
                        return {
                          style: {
                            backgroundColor: isSelected ? "#fff490" : "",
                            // fontWeight: isSelected ? "bold" : "normal",
                          },
                        };
                      }}
                    />
              </Card>
              <Card className="project-header-card border mb-2 mt-4 ml-3 text-center">
              <h4 className="project-header-title-deliveries mb-0">
                  <b>Submission Name : </b> 
                  {selectedSubmission && selectedSubmission.submissionName ? selectedSubmission.submissionName : ''}
              </h4>
              </Card>
                <LoadingOverlay
              active={loadScreen}
              styles={{
                overlay: (base) => ({
                  ...base,
                  background: '#fff',
                  opacity: 1,
                }),
                content: (base) => ({
                  ...base,
                  color: '#000',
                }),
              }}
              spinner={<Loader active type="ball-pulse" />}
              text='Loading your Assets...'
            >
              <Card className="p-2 mb-2 ml-3" style={{ borderRadius: '8px' }}>

            <div className="d-flex align-items-start ml-3 mb-1">
                  <h6 className="mr-2 mb-0"><b>Submission Note : </b></h6>
                  {selectedSubmission && typeof selectedSubmission.note === 'string' &&
                  selectedSubmission.note.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim() !== '' &&
                  selectedSubmission.note !== '[]' ? (
                      <div 
                        dangerouslySetInnerHTML={{ __html: selectedSubmission.note }}
                      />
                    ) : (
                      <span className="mb-0"></span>
                  )}
                </div>
              </Card>
              <Card className="ml-3 mt-2 card-of-problemarea p-3 mb-3">
                <Row>
                <Col md={12}>
                <div className='d-flex'>
                <h6
                  className={`mr-2 ${selectedCurrentPage === 1 ? "selected-my-tasks" : "not-selected-tasks"
                    }`}
                  onClick={() => handleSelectedTab(1,allAssetsList)}
                  style={{ cursor: "pointer" }}
                >
                  <b>Documents</b>
                </h6> 

                <h6
                  className={`mr-2 ${selectedCurrentPage === 2 ? "selected-my-tasks" : "not-selected-tasks"
                    }`}
                  onClick={() => handleSelectedTab(2,allAssetsList)}
                  style={{ cursor: "pointer" }}
                >
                  <b>Graphics</b>
                </h6>
                </div>
              
                </Col>
              
                <Col md={12}>
                {selectedCurrentPage ===1?
                <ProjectDocumentDeliveriesDetails
                handleImgdetails={handleImgdetails}
                documentAssets={documentAssets}
                setAllAssetsList={setAllAssetsList}
                documentStatusCount={documentStatusCount}
                documentTotal={documentTotal}
                setDocumentAssets={setDocumentAssets}
                setDocumentStatusCount={setDocumentStatusCount}
                setDocumentTotal={setDocumentTotal}
                setGraphicsStatusCount={setGraphicsStatusCount}
                setGraphicsTotal={setGraphicsTotal}
                />:
                <ProjectGraphicsDeliveriesDetails
                handleImgdetails={handleImgdetails}
                setAllAssetsList={setAllAssetsList}
                graphicsAssets={graphicsAssets}
                loggedInUser={loggedInUser}
                     selectedProjectData={props.selectedProjectData}
                     projectPermissions={props.projectPermissions}
                     submissionData={selectedSubmission}
                     setAssetList={setGraphicsAssets}
                     setSubmissionList={setSubmissionList}
                     selectedImage={selectedFileObject}
                     setSelectedImage={setSelectedFileObject}
                     action={true}
                     flag={true}
                     setGraphicsStatusCount={setGraphicsStatusCount}
                     setGraphicsTotal={setGraphicsTotal}
                     setDocumentStatusCount={setDocumentStatusCount}
                     setDocumentTotal={setDocumentTotal}
                     graphicsStatusCount={graphicsStatusCount}
                     graphicsTotal={graphicsTotal}
                    //  setSelectedImageAsset={setSelectedFileObject}
                />}
                </Col>
                </Row>
              </Card>
              </LoadingOverlay>
              <CustomModal
                isOpen={isCommentsPopUpOPen}
                toggle={() => setIsCommentsPopUpOPen(false)}
                size="xl"
                header={<p title={selectedFileObject && selectedFileObject.assetName} className="comment-paragraph-Project-asin-title">{selectedFileObject && selectedFileObject.assetName}</p>}
                className="curve-popup "
            >
               
                    
                     <ProjectDashDeliveriesImagesDetails
                     setAllAssetsList={setAllAssetsList}
                     loggedInUser={loggedInUser}
                     selectedProjectData={props.selectedProjectData}
                     projectPermissions={props.projectPermissions}
                     submissionData={selectedSubmission}
                     setDocumentAssets={setDocumentAssets}
                     setDocumentStatusCount={setDocumentStatusCount}
                     setDocumentTotal={setDocumentTotal}
                     setGraphicsStatusCount={setGraphicsStatusCount}
                     setGraphicsTotal={setGraphicsTotal}
                  
                     setAssetList={setDocumentAssets}
                     setSubmissionList={setSubmissionList}
                     selectedImage={selectedFileObject}
                     setSelectedImage={setSelectedFileObject}
                     action={false}
                     setSelectedImageAsset={setSelectedFileObject}
                     onClose={() => setIsCommentsPopUpOPen(false)}
                     />
                   
                {/* </LoadingOverlay> */}
            </CustomModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,

});
export default connect(mapStateToProps)(ProjectDashDeliveries);
